module.exports = "img/modular-bw-logo.8aac5a1.svg";